import React from 'react';
import './SequenceDiagram.scss';
import classNames from 'classnames';

function SequenceDiagram({
    actors, interactions
}) {

    const actorWidth = 250;
    const actorHeight = 60;
    const gapWidth = 150;
    const horizontalMargin = 10;
    const width = actors.length * actorWidth + (actors.length - 1) * gapWidth + horizontalMargin * 2;
    let height = actorHeight + 60;

    // build interactions, also increments height to correct size
    const interactionSegment = interactions.map((interaction, i) => {
        const xStart = ((actorWidth + gapWidth) * interaction.start) + actorWidth / 2 + horizontalMargin;
        const xEnd = ((actorWidth + gapWidth) * interaction.end) + actorWidth / 2 + horizontalMargin;
        let y = height;
        let text = null, returnLine = null;

        // interaction description text
        if (interaction.text) {
            text = <TextWithBackground
                x={(xStart + xEnd) / 2}
                y={y}
                style={{fontSize: '18px', fontFamily: 'Verdana, Helvetica, Sans-Serif'}}
                textAnchor="middle"
            >
                {interaction.text}
            </TextWithBackground>;
            y += 16;
            height += 16;
        }

        // line
        let line = <InteractionLine x1={xStart} x2={xEnd} y1={y} y2={y} stroke="#000000" fill="none" backwards={interaction.backwards} />
        height += 20;

        // optional line that goes the opposite direction
        if (interaction.includeReturn) {
            y += 16;
            height += 16;
            returnLine = <InteractionLine x1={xStart} x2={xEnd} y1={y} y2={y} stroke="#000000" fill="none" backwards={!interaction.backwards} />;
        }

        height += 30;
        return <g key={i}>
            {text}
            {line}
            {returnLine}
        </g>
    });

    const isInternetExplorer = !!window.document.documentMode;
    const paddingHackPercent = `${100 * height / width}%`;

    return <div
            className={classNames("sequence-diagram", [isInternetExplorer && "ie-fix"])}
            style={isInternetExplorer ? {paddingTop: paddingHackPercent} : {}}
        >
        <svg
            viewBox={`0 -10 ${width} ${height}`}
            style={isInternetExplorer ? {marginTop: '-' + paddingHackPercent} : {}}
        >
            <defs>
                <marker viewBox="0 0 5 5" markerWidth="5" markerHeight="5" orient="auto" refX="0" refY="2.5" id="blockArrowStart">
                    <path d="M 5 0 L 0 2.5 L 5 5 z">
                    </path>
                </marker>
                <marker viewBox="0 0 5 5" markerWidth="5" markerHeight="5" orient="auto" refX="5" refY="2.5" id="blockArrowEnd">
                    <path d="M 0 0 L 5 2.5 L 0 5 z">
                    </path>
                </marker>
                <marker viewBox="0 0 9.6 16" markerWidth="4" markerHeight="16" orient="auto" refX="9.6" refY="8" id="openArrowEnd">
                    <path d="M 9.6,8 1.92,16 0,13.7 5.76,8 0,2.286 1.92,0 9.6,8 z">
                    </path>
                </marker>
                <filter x="0" y="0" width="1" height="1" id="textBackground">
                    <feFlood floodColor="rgb(245, 245, 245)"/>
                </filter>
            </defs>
            {/* render actors and swimlanes */ }
            {actors.map((actor, i) => {
                const x = (actorWidth + gapWidth) * i + horizontalMargin;
                return <g key={i} >
                    {/* actor box */}
                    <rect x={x} y="0" width={actorWidth} height={actorHeight} style={{strokeWidth: '2px'}} stroke="#243d51" fill="#ffffff">
                    </rect>
                    <text x={x + actorWidth / 2} y={actorHeight / 2 + 1} style={{fontSize: '18px', fontFamily: 'Verdana, Helvetica, Sans-Serif', fontWeight: 'bold'}} dominantBaseline="middle" textAnchor="middle" fill="#243d51">
                        {actor.name}
                    </text>
                    {/* swim lane */}
                    <line x1={x + actorWidth / 2} x2={x + actorWidth / 2} y1={actorHeight} y2={height} style={{strokeWidth: '2px'}} stroke="#333" fill="none">
                    </line>
                </g>
            })}
            {/* render interaction lines */}
            {interactionSegment}
        </svg>
    </div>;
}

/**
 * An interaction line, shows the direction its pointing
 */
function InteractionLine({
    backwards,
    dashed,
    ...props
}) {

    let style = {
        strokeWidth: '2px',
    };

    if (backwards) {
        style = {...style, markerStart: 'url("#blockArrowStart")', strokeDasharray: '6px, 6px'};
    } else {
        style = {...style, markerEnd: 'url("#blockArrowEnd")'};
    }

    return <line {...props} style={style}></line>;
}

/**
 * Text with a solid background
 */
function TextWithBackground({
    style,
    children,
    ...props
}) {
    // some hackery, render the 'text' replace with a solid block
    // forming a background, so you can read the text when it overlays a line
    return <>
        <text {...props} style={{...style, filter: 'url(#textBackground)'}}>
            {children}
        </text>
        <text {...props} style={style}>
            {children}
        </text>
    </>;
}

export default SequenceDiagram;